import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import StudentChurnTable from './StudentChurnTable';
import { StudentChurnListService } from '../../services/CustomerSuccessKpiListService';
import { get } from 'lodash';

class StudentChurnDetailTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentChurnListService.load();
  }

  render() {
    return (
      <StudentChurnTable
        loading={StudentChurnListService.fetchCurrent.fetching || StudentChurnListService.fetchPrevious.fetching}
        values={toJS(StudentChurnListService.getCompaniesByType(this.props.type, this.props.typeId))}
        feedbackColorRender={StudentChurnListService.getFeedbackColor}
        onSelect={(row) =>
          browserHistory.push(
            `/kpis/customer-success/${this.props.type}/${get(this.props, 'typeId', 'NA')}/company/${row.id}/details`
          )
        }
        formatter={StudentChurnListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentChurnDetailTableContainer);
